import React, { useMemo } from "react";
import { Notifications} from "@netapp/bxp-design-system-react";
import { useSelector, useDispatch } from "react-redux";
import { ErrorMessageWithLink } from "./error/errorMessages";

export default React.memo(() => {
    const _notifications = useSelector(state => state.notifications.notifications);
    const dispatch = useDispatch();
    
    const richNotifications = useMemo(() => {
        return _notifications
            .filter(notification => notification.isRich) // here we are filtering rich notifications(with link)
            .map(notification => {
                const richContent = <ErrorMessageWithLink message={notification.moreInfo} hyperLink={notification.hyperLink} linkText={notification.linkText} />;

                if (!notification.isFatal) {
                    return {
                        ...notification,
                        key: notification.notificationId,
                        moreInfo: richContent,
                        onClose: () => {
                            dispatch({
                                type: "NOTIFICATIONS:REMOVE",
                                payload: {
                                    notificationId: notification.notificationId
                                }
                            });
                        }
                    };
                } else {
                    return {
                        ...notification,
                        key: notification.notificationId,
                        moreInfo: richContent
                    };
                }
            });
    }, [_notifications, dispatch]);

    return <Notifications notifications={richNotifications} isGlobal={true} />;
});
